import { useState, useEffect, useRef } from "react";
import axios from "axios";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";
import AdminCustomInput from "../../../../components/CommonComponents/AdminCustomInput"; // adjust path
import Wrapper from "../../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";
import MessageSubHeading from "../../../../components/CommonComponents/MessageSubHeading";
import AdminSaveHeader from "../../../../components/CommonComponents/AdminSaveHeader";
import { toast } from "react-toastify";
// import "./site_setting.css"; // includes .red-border, .errorred

function App_Setting(props) {
  const [formData, setFormData] = useState({
    android_url: "",
    ios_url: "",
    android_tv: "",
    Firetv_url: "",
    samsungtv_url: "",
    Lgtv_url: "",
    Rokutv_url: "",
  });

  const [formDataError, setFormDataError] = useState({});
  const [emojiWarningField, setEmojiWarningField] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const combinedRef = useRef({});

  const access_token = localStorage.getItem("access_token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/setting/app`, {
          headers,
        });
        const settings = response?.data?.appsetting[0];
        setFormData(settings || {});
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  const isValidUrl = (url) => /^(http:\/\/|https:\/\/)/i.test(url);

  const handleInput = (e) => {
    const { name, value } = e.target;
    const emojiRegex =
      /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;

    let cleaned = value;
    if (emojiRegex.test(value)) {
      cleaned = value.replace(emojiRegex, "");
      setEmojiWarningField(name);
    } else if (emojiWarningField === name) {
      setEmojiWarningField(null);
    }

    setFormData((prev) => ({ ...prev, [name]: cleaned }));
    setFormDataError((prev) => ({ ...prev, [name]: "" }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (value && !isValidUrl(value)) {
      setFormDataError((prev) => ({
        ...prev,
        [name]: "URL must start with http:// or https://",
      }));
    }
  };

  const renderEmojiWarning = (fieldName) =>
    emojiWarningField === fieldName ? (
      <div className="errorred mt-1">Emojis are not allowed and have been removed</div>
    ) : null;

  const handleUpdate = async () => {
    const fieldsToValidate = [
      "android_url",
      "ios_url",
      "android_tv",
      "Firetv_url",
      "samsungtv_url",
      "Lgtv_url",
      "Rokutv_url",
    ];

    const errors = {};
    fieldsToValidate.forEach((field) => {
      const val = formData[field];
      if (val && !isValidUrl(val)) {
        errors[field] = "URL must start with http:// or https://";
      }
    });

    if (Object.keys(errors).length > 0) {
      setFormDataError(errors);
      const firstInvalid = fieldsToValidate.find((f) => errors[f]);
      if (combinedRef.current[firstInvalid]) {
        combinedRef.current[firstInvalid].focus();
      }
      return;
    }

    setProcessing(true);
    setShowOverlay(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/setting/app`,
        formData,
        { headers }
      );

      const result = response?.data;
      if (result?.status) {
        props?.setApiresponsealert(result);
        props?.setShowalert(true);
        toast.success(result?.message || "App settings updated successfully");
      } else {
        props?.setApiresponsealert(result);
        props?.setShowalert(true);
        setProcessing(false);
        setShowOverlay(false);
        toast.error(result?.message || "Failed to update app settings");

      }
    } catch (error) {
      console.error(error);
      setProcessing(false);
      setShowOverlay(false);
    } finally {
      setProcessing(false);
      setShowOverlay(false);
    }
  };

  return (
    <>
      <AdminBackNavigation path="/settings" text="Back" />

      <AdminSaveHeader heading={"App Version & App URL Settings"} saveText={"Update"} saveMethod={handleUpdate} loading={processing} />

      <Wrapper>
        <MessageHeading text={'App Version'} />
        <MessageLabel text={'iOS App Version'} />
        <MessageSubHeading text={'Set the minimum required iOS app version. Users with an older version will be prompted to update their app.'} />
        <AdminCustomInput value={formData.iOS_app_version} onChange={handleInput} name="iOS_app_version" placeHolder="Enter iOS app version" />
      </Wrapper>

      <Wrapper>
        <MessageHeading text={'App URL Settings'} />
        {[
          { label: "Android URL", name: "android_url" },
          { label: "IOS URL", name: "ios_url" },
          { label: "Android TV", name: "android_tv" },
          { label: "Fire TV", name: "Firetv_url" },
          { label: "Samsung TV", name: "samsungtv_url" },
          { label: "Lg TV", name: "Lgtv_url" },
          { label: "Roku TV", name: "Rokutv_url" },
        ].map(({ label, name }) => (
          <div key={name} className="text-start mt-2">
            <MessageLabel text={label} />
            <AdminCustomInput type="text" name={name} value={formData[name]} onChange={handleInput} onBlur={handleBlur} placeHolder={label} ref={(el) => (combinedRef.current[name] = el)} error={formDataError?.[name]} />
            {renderEmojiWarning(name)}
          </div>
        ))}
      </Wrapper>

    </>
  );
}

export default App_Setting;
